import React, { Component } from "react";
import Predefine_2_CrewNeck_Cricket from "../components/Predefine_2_CrewNeck_Cricket/Predefine_2_CrewNeck_Cricket";

export class Predefine_2_CrewNeck_CricketPage extends Component {
  render() {
    return <Predefine_2_CrewNeck_Cricket />;
  }
}

export default Predefine_2_CrewNeck_CricketPage;
